import { useNavigate } from "@tanstack/react-router";
import { PtoBanner } from "@/components/team/PtoBanner";
import { usePendingApprovals } from "@/hooks/use-team";
import { isPageBuilt, PAGE_HREFS } from "@/lib/features";
import { bannerFor } from "@/lib/team/pending";

/**
 * "N PTO requests to approve · Review" on Home (DECISIONS 'Pending PTO is visible and alerts
 * managers'). N = the viewer's team items + HR-routed ones for the HR approver, cancel asks
 * included (`bannerFor`, the one banner rule). Review opens PTO -> Approvals when HR items wait,
 * else My Team with its PTO requests dialog open. Nothing at 0.
 */
export function HomePtoBanner() {
  const navigate = useNavigate();
  const banner = bannerFor(usePendingApprovals().data, isPageBuilt(PAGE_HREFS.pto));
  return (
    <PtoBanner
      count={banner?.count ?? 0}
      onReview={() => {
        if (banner?.href === "/dashboard/team")
          void navigate({ to: "/dashboard/team", search: banner.search });
        else if (banner)
          void navigate({ to: "/dashboard/pto", search: { tab: banner.search.tab } });
      }}
    />
  );
}
